import { IPermissionMatrix } from '@directives/has-permissions/permission-matrix/index';
import { UserRole } from '@models/enums/user-role.enum';

export type securityPermissionType = 'security_view';

export const securityPermissionMatrix: IPermissionMatrix<securityPermissionType> = {
  security_view: [UserRole.user]
};
